import React from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  ThemeProvider,
  Typography,
  createTheme
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import { Controller, useFormContext } from "react-hook-form";
import { enumToArray } from "../../../../shared/models/models";
import { ChangeRfq, urgencyStatus } from "../../models/models";
import { UrgencyCode } from "../../../../common/models/CommonModels";

const RfqDetailsStep = () => {
  const { register, trigger, control, formState: { errors } } = useFormContext<ChangeRfq>();

  const theme = createTheme({
    components: {
      MuiStack: {
        styleOverrides: {
          root: {
            paddingTop: "0 !important"
          }
        }
      }
    }
  });

  return (
    <ThemeProvider theme={theme}>
      <Box className="mt-5">
        <Typography fontSize={36} fontWeight={500} className="heading-1">
          Create a new RFQ
        </Typography>
      </Box>

      <Box className="mt-5">
        <Typography fontSize={24} fontWeight={500} className="heading-2">
          RFQ details
        </Typography>
      </Box>

      <Box>
        <Box className="mt-4 grid grid-cols-2 gap-4">
          <Box>
            <InputLabel>Urgency</InputLabel>
            <FormControl className="w-full" required>
              <Select
                key="urgencyCode"
                defaultValue={`${UrgencyCode.any}`}
                onClose={() => setTimeout(() => trigger("urgencyCode"))}
                {...register("urgencyCode", { required: "Field is required" })}
                error={!!errors.urgencyCode}
              >
                {enumToArray<UrgencyCode>(UrgencyCode).map((code) => (
                  <MenuItem key={code} value={code}>
                    {urgencyStatus(code)}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText error>{errors.urgencyCode?.message}</FormHelperText>
            </FormControl>
          </Box>

          <Box>
            <InputLabel required>Last call</InputLabel>

            <FormControl className="w-full">
              <Controller
                control={control}
                name="lastCall"
                rules={{ required: "Field is required" }}
                render={({ field }) => (
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      {...field}
                      value={moment(field.value)}
                      onChange={(value) => field.onChange(value?.toDate())}
                      format="DD.MM.YYYY"
                      disablePast
                    />
                  </LocalizationProvider>
                )}
              />

              <FormHelperText error>{errors.lastCall?.message}</FormHelperText>
            </FormControl>
          </Box>
        </Box>

        {/* <Box className="mt-4">
          <RadioGroup defaultValue={RfqCode.public}>
            {enumToArray<RfqCode>(RfqCode).map((code) => (
              <FormControlLabel
                label={RfqStatus(code)}
                value={code}
                control={<Radio sx={{ color: "#ACAEB3" }} />}
                sx={{ marginRight: 5 }}
              />
            ))}
          </RadioGroup>
        </Box> */}
      </Box>
    </ThemeProvider>
  );
};

export default RfqDetailsStep;
